<template>
  <div>
    <ToggleButton
      class="mb-0"
      v-bind="toggler"
      v-b-tooltip="page.published ? 'Publicada' : 'Publicar'"
      :value="page.published ? true : false"
      :key="published"
      @change="toggle(page, $event.value)"
    />
    <BModal
      id="modal-page-setup"
      modal-class="modal-no-header-no-footer"
      ref="modal-page-setup"
      hide-header="hide-header"
      hide-footer="hide-footer"
    >
      <template slot="default">
        <button
          class="close"
          type="button"
          aria-label="Close"
          @click="$refs['modal-page-setup'].hide()"
        >
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title align-items-center text-center">
          {{ __('Configurar landing page') }}
          <h6 class="modal-subtitle">
            {{ __('Não sabe como publicar uma LP?') }}<br><a
              href="https://salesflowcrm.movidesk.com/kb/article/405245/como-personalizar-o-link-de-sua-landing-page"
              target="_blank"
            >
              <u>{{ __('Clique aqui') }}</u></a> {{ __('e veja como.') }}
          </h6>
        </h4>
        <form
          class="px-20px"
          method="post"
          @submit.prevent="save()"
        >
          <div class="form-group">
            <label>{{ __('Título') }}</label>
            <input
              class="form-control"
              type="text"
              v-model="page.title"
              :placeholder="__('Utilizado para identificar sua LP dentro do Salesflow')"
              required="required"
            >
            <p
              class="form-text text-danger"
              v-if="errors['title']"
            >
              {{ errors['title'][0] }}
            </p>
          </div>
          <div class="form-group">
            <label>{{ __('Meta descrição') }}</label>
            <textarea
              class="form-control"
              rows="5"
              v-model="page.meta_description"
              :placeholder="__('Altere a descrição da página de SEO')"
            />
            <p
              class="form-text text-danger"
              v-if="errors['meta_description']"
            >
              {{ errors['meta_description'][0] }}
            </p>
          </div>
          <div class="form-group">
            <label>{{ __('Endereço') }}</label>
            <div class="d-flex align-items-center">
              <label class="mt-1px mr-2 mb-0">http://</label>
              <input
                class="form-control"
                type="text"
                v-model="page.domain"
                placeholder="conteudo.dominio.com.br"
              >
              <label class="mt-1px mx-2 mb-0">/</label>
              <input
                class="form-control"
                type="text"
                v-model="page.slug"
              >
            </div>
            <p class="form-text">
              <span
                class="text-danger"
                v-if="errors['domain']"
              >{{ errors['domain'][0] }}<br></span><span
                class="text-danger"
                v-if="errors['slug']"
              >{{ errors['slug'][0] }}<br></span><span
                class="text-danger"
                v-if="errors['error']"
              >{{ errors['error'] }}<br></span><span class="small-text">{{ __('Exemplo:') }} conteudo.seusite.com.br/download-ebook</span>
            </p>
          </div>
          <div class="form-group">
            <label>{{ __('Categoria') }}</label>
            <InputCategory
              type="page"
              :model="page.id"
              :value="page.categories"
            />
          </div>
          <div class="modal-footer default-modal-footer">
            <button
              class="btn btn-primary f-w-500"
              type="submit"
              :disabled="saving"
            >
              <i
                class="fa fa-circle-o-notch fa-spin"
                v-if="saving"
              /><span v-else>{{ __('Salvar') }}</span>
            </button>
          </div>
        </form>
      </template>
    </BModal>
  </div>
</template>

<script>
import { BModal, VBTooltip } from 'bootstrap-vue';

export default {
  components: {
    BModal,
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  props: {
    page: {
      type: Object,
      required: true,
    },
  },

  data () {
    return {
      errors: [],
      saving: false,
      published: 0,
    };
  },

  computed: {
    toggler: () => ({
      'width': 58,
      'height': 29,
      'color': {
        checked: '#FFF',
        unchecked: '#FFF',
      },
      'switch-color': {
        checked: '#2CEBA9',
        unchecked: '#B2A8C1',
      },
    }),
  },

  mounted () {
    Bus.$on('openPageSetup', () => this.openModal());

    this.$root.$on('bv::modal::hide', (event, modalId) => {
      if (modalId == 'modal-page-setup') {
        this.$http.get(`/page/${this.page.id}`)
          .then(({ data }) => {
            this.page.slug = data.slug;
            this.page.title = data.title;
            this.page.domain = data.domain;
            this.page.published = data.published;
            this.page.public_url = data.public_url;
            this.page.meta_description = data.meta_description;
            this.published += 1;
            this.errors = [];
          });
      }
    });
  },

  methods: {
    toggle (page, flag) {
      this.page.published = flag;

      this.save();
    },

    openModal () {
      this.$refs['modal-page-setup'].show();
    },

    save () {
      this.errors = [];
      this.saving = true;

      const ignore = ['editable', 'content', 'html', 'created_at', 'theme', 'hits', 'updated_at', 'id'];
      const filtered = Object.keys(this.page).filter((k) => ! ignore.includes(k));
      const page = filtered.reduce((obj, k) => Object.assign(obj, { [k]: this.page[k] }), {});

      this.$http.put(`/page/${this.page.id}`, page)
        .then(({ data }) => {
          Alert.success(this.__('Página salva!'));

          this.$refs['modal-page-setup'].hide();

          Bus.$emit('pageUpdated', data.page);
        })
        .catch(({ data }) => {
          this.errors = data;

          this.openModal();
        })
        .finally((response) => {
          this.saving = false;
        });
    },
  },
};
</script>
